export enum FeatureToggle {
  customersAndOrdersOrderDetailView = 'rt_cx_admin_migration_order_detail',
  customersAndOrdersCustomerOrderHistoryView = 'rt_cx_admin_migration_order_history',
  customersAndOrdersCustomerSearchView = 'rt_cx_admin_migration_customer_search',
}
